import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { ICONS } from 'components/Icons';
import { SCREEN } from 'scenes/common/types/screen';

const HomeForRentImage = styled.img`
  height: 8rem;
  margin-top: -1rem;

  @media (min-width: ${SCREEN.SMALL}px) {
    height: 12rem;
  }
`;

export const QuoteSaved: FunctionComponent = () => (
  <HomeForRentImage
    src={ICONS.DEFAULT.LANDLORD}
    tabIndex={-1}
    alt="Successfully saved quote - home for rent graphic"
  />
);
